import React, { useContext, ReactNode } from 'react';
import { Tooltip } from '../../molecules/Tooltip';
import { Theme, ThemeContext } from '../../utilities/theme';

const LabelElement = ({
  htmlFor,
  children,
  inline = false,
}: {
  htmlFor: string;
  children: ReactNode;
  inline?: boolean;
}) => (
  <label
    data-id="label-container"
    className={`flex ${inline ? 'mb-4 flex-row last:mb-0' : 'mb-0 flex-col'}`}
    htmlFor={htmlFor}
  >
    {children}
  </label>
);
const Required = ({ theme }: { theme?: Theme }) =>
  theme === 'futuro' ? null : (
    <span
      className={`${
        theme && ['flat-slate', 'futuro'].includes(theme)
          ? 'text-strong'
          : 'background-special'
      }`}
    >
      *
    </span>
  );
type LabelTextT = {
  label: string;
  required?: boolean;
  tooltip?: string;
  theme?: Theme;
};
const LabelText = (props: LabelTextT) => (
  <div
    className="mb-1 flex items-end text-base font-normal md:whitespace-nowrap md:text-xs"
    data-id="label-text"
  >
    {props.label}
    {props.required ? <Required theme={props.theme} /> : ''}
    {props.tooltip ? (
      <Tooltip
        position="static"
        message={{ id: props.tooltip, defaultMessage: props.tooltip }}
      />
    ) : undefined}
  </div>
);
type LabelPropsT = {
  children?: ReactNode;
  htmlFor: string;
  theme?: Theme;
  required?: boolean;
  label: string;
  tooltip?: string;
  inline?: boolean;
};
const Label: React.FunctionComponent<LabelPropsT> = ({
  children,
  htmlFor,
  theme,
  required,
  label,
  tooltip,
  inline,
}: LabelPropsT) => {
  const themeContext = useContext(ThemeContext);
  const currentTheme = theme ?? themeContext;
  return (
    <LabelElement htmlFor={htmlFor} inline={inline}>
      <div className="mb-1 flex items-end text-base font-normal md:whitespace-nowrap md:text-xs">
        <LabelText
          label={label}
          required={required}
          tooltip={tooltip}
          theme={currentTheme}
        />
      </div>
      {children}
    </LabelElement>
  );
};
Label.defaultProps = {
  required: false,
};
export default Label;
